import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MoreVertical, ChevronUp, ChevronDown, Edit2, Trash2, Copy } from "lucide-react";

interface RoomManagementMenuProps {
  roomIndex: number;
  totalRooms: number;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRename: () => void;
  onDelete: () => void;
  onDuplicate?: () => void;
}

const RoomManagementMenu = ({
  roomIndex,
  totalRooms,
  onMoveUp,
  onMoveDown,
  onRename,
  onDelete,
  onDuplicate,
}: RoomManagementMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0">
          <MoreVertical className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 bg-popover">
        <DropdownMenuItem onClick={onMoveUp} disabled={roomIndex === 0}>
          <ChevronUp className="w-4 h-4 mr-2" />
          Move Up
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onMoveDown} disabled={roomIndex === totalRooms - 1}>
          <ChevronDown className="w-4 h-4 mr-2" />
          Move Down
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onRename}>
          <Edit2 className="w-4 h-4 mr-2" />
          Rename Room
        </DropdownMenuItem>
        {onDuplicate && (
          <DropdownMenuItem onClick={onDuplicate}>
            <Copy className="w-4 h-4 mr-2" />
            Duplicate Room
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onDelete} className="text-destructive focus:text-destructive">
          <Trash2 className="w-4 h-4 mr-2" />
          Remove from this checklist
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RoomManagementMenu;
